export default __webpack_public_path__ + "static/media/louis.221d5bbc.jpg";